var hcja = hcja || {};

hcja.common = {
    clickHandlerClass: function (workname, isAjaxCall) {
        var clicked = false;
        var count = 0;
        var eventArg = function (disableBtn, resultValue) {
            this.disableButton = disableBtn;
            this.result = resultValue;
        };
        var evt = new eventArg(false, true);

        var callback = function (target, disable, result) {
            target.disableButton = disable;
            target.result = result;
        };

        var defaultFunction = function (target) {
            target.disableButton = true;
            target.result = true;
        };

        var clickFunc = function () {
            try {
                if (evt.disableButton)
                    return false;
                else
                    evt.disableButton = true;
                if (workname !== undefined) {


                    if (isAjaxCall) {
                        workname(evt, callback);
                    }
                    else {
                        workname(evt);
                    }

                    return evt.result;
                }
                else {
                    return false;
                }
            }
            catch (err) {
                evt.disableButton = false;
                alert("An error has occured. Please try again. \n"+err);
            }
        };
        return clickFunc;
    },

    exitPageClass: function (buttonName, modalName, hrefString) {
        buttonName.attr('href', hrefString);
        buttonName.attr('data-toggle', null);
        buttonName.attr('data-parent', null);
        buttonName.attr('aria-expanded', null);
        buttonName.attr('aria-controls', null);
        modalName.modal('show');
        return false;
    }
};



